import $ from 'jquery';

const wikiSearch = () => {
  const input = $('.wikisearch-text-container')
    .children('form')
    .find('input');
  const button = $('#wikisearch-submit');
  button.click(e => {
    e.preventDefault();
    window.location = `${window.location.href}/wikiForm/${input.val()}/`; // URL set for developing purposes only. Todo: change to absolute path on live server eg. /wiki/${input.val()}, trailing slash for multilang purposes needed
  });
};

export default wikiSearch;

// uncomment for DEV
/*
import $ from 'jquery';

const wikiSearch = () => {
  const input = $('.wikisearch-text-container')
    .children('form')
    .find('input[name=wikisearch]');
  const button = $('#wikisearch-submit');
  button.click(e => {
    e.preventDefault();
    window.location = `/stetson-europe/wikiForm/${input.val()}/`; // URL set for developing purposes only. Todo: change to absolute path on live server eg. `/wikiForm/${input.val()}/`, trailing slash for multilang purposes needed
  });
};

export default wikiSearch;

*/



// WEBPACK FOOTER //
// ./wp/wp-content/themes/stetson-europe-chisel/src/scripts/modules/wiki-search.js